import { MessageType } from './MessageType';

export const ResolutionType = {
  YES: 'yes',
  NO: 'no',
} as const;

export const ResolutionMessageList = [
  MessageType.RESOLUTION,
  MessageType.ANY_OTHER_HELP_RESOLUTION,
  MessageType.METADATA_RESOLUTION,
  MessageType.OVERLONG_AI_CONVERSATION_RESOLUTION,
  MessageType.STALE_AI_CONVERSATION_RESOLUTION,
  MessageType.USER_LOGIN_FROM_AI,
  MessageType.VOICE_CONFIRMATION,
  MessageType.LANDING_AI_VOICE_CONFIRMATION,
  MessageType.VOICE_NATIVE_MICRO_ACCESS_CONFIRMATION,
  MessageType.CANCEL_REQUEST,
  MessageType.END_LIVE_CHAT,
  MessageType.END_VOICE_CALL,
  MessageType.RESTART_CHAT_RESOLUTION,
] as const;

export type ResolutionKind = (typeof ResolutionType)[keyof typeof ResolutionType];
export type ResolutionMessageType = (typeof ResolutionMessageList)[number];
